import React from 'react'
import { PageTitle } from '_metronic/layout/core'
import { WithChildren } from '_metronic/helpers'
import PageBreadCrumb from 'Presentation/Components/PageBreadCrumb'

import useViewModel from './ViewModel'
import clsx from 'clsx'

const PileFormView: React.FC = () => {
  const {
    isCreate,
    isLoading,
    isSubmitting,
    formState,
    formError,
    onChangeFormState,
    onSubmit,
    onCancel,
  } = useViewModel()

  // Regular expression to allow only integer or float input
  const numericInputPattern = /^[0-9]*\.?[0-9]*$/

  return (
    <ViewPageTitle isCreate={isCreate} title={formState.itemTitle}>
      <div className='mb-5'>
        <PageBreadCrumb />
      </div>

      <div className='card border border-2'>
        {/* begin:: Header */}
        <div className='card-header'>
          <div className='card-title fw-bold'></div>
          <div className='card-toolbar'>
            <button className='btn btn-sm btn-secondary fw-bold me-4' onClick={onCancel}>
              ยกเลิก
            </button>
            <button
              className='btn btn-sm btn-primary fw-bold'
              onClick={onSubmit}
              disabled={isLoading || isSubmitting}>
              บันทึก
            </button>
          </div>
        </div>

        <div className='card-body'>
          <div className='row gy-3'>
            <div className='col-12 col-xl-4'>
              <label className='mb-2'>
                ชื่อเสาเข็ม (Pile Title) <span className='required' />
              </label>
              <input
                type='text'
                className={clsx('form-control form-control-sm', {
                  'is-invalid': formError.itemTitle,
                })}
                value={formState.itemTitle}
                onChange={(e: any) => onChangeFormState('itemTitle', e.target.value)}
              />
            </div>

            <div className='col-12 col-xl-4'>
              <label className='mb-2'>
                รหัสเสาเข็ม (Pile Code) <span className='required' />
              </label>
              <input
                type='text'
                className={clsx('form-control form-control-sm', {
                  'is-invalid': formError.itemCode,
                })}
                value={formState.itemCode}
                onChange={(e: any) => onChangeFormState('itemCode', e.target.value)}
              />
            </div>

            <div className='col-12 col-xl-4'>
              <label className='mb-2'>
                ความสูงของเสาเข็ม (Height) <span className='required' />
              </label>
              <input
                type='text'
                className={clsx('form-control form-control-sm', {
                  'is-invalid': formError.height,
                })}
                value={formState.height}
                onChange={(e: any) =>
                  numericInputPattern.test(e.target.value) &&
                  onChangeFormState('height', e.target.value)
                }
              />
            </div>

            <div className='col-12 col-xl-4'>
              <label className='mb-2'>
                ความกว้างของเสาเข็ม (Width) <span className='required' />
              </label>
              <input
                type='text'
                className={clsx('form-control form-control-sm', {
                  'is-invalid': formError.width,
                })}
                value={formState.width}
                onChange={(e: any) =>
                  numericInputPattern.test(e.target.value) &&
                  onChangeFormState('width', e.target.value)
                }
              />
            </div>

            <div className='col-12 col-xl-4'>
              <label className='mb-2'>
                น้ำหนัก (Weight) <span className='required' />
              </label>
              <input
                type='text'
                className={clsx('form-control form-control-sm', {
                  'is-invalid': formError.weight,
                })}
                value={formState.weight}
                onChange={(e: any) =>
                  numericInputPattern.test(e.target.value) &&
                  onChangeFormState('weight', e.target.value)
                }
              />
            </div>
          </div>
        </div>
      </div>
    </ViewPageTitle>
  )
}

const ViewPageTitle: React.FC<WithChildren & { isCreate: boolean; title?: string }> = ({
  children,
  isCreate,
}) => {
  const headerText = isCreate ? 'เพิ่มเสาเข็ม' : `แก้ไขเสาเข็ม​`

  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            isActive: false,
            isSeparator: false,
            path: '/pile',
            title: 'รายการเสาเข็มทั้งหมด',
            icon: '/media/icons/duotune/files/fil024.svg',
          },
          {
            isActive: true,
            isSeparator: false,
            path: '#',
            title: 'เสาเข็ม',
            icon: '/media/icons/duotune/files/fil024.svg',
          },
        ]}>
        {headerText}
      </PageTitle>

      {children}
    </>
  )
}

export default PileFormView
